import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'repairCasesController';
export default {
    /**
     * 信修案件查询
     */
    repairCasesQuery: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'repairCasesQuery',
        type: requestType.Get
    },
    /**
     *  添加案件修复信息
     */
    toRepair: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'toRepair',
        type: requestType.Post
    },
    /**
     * 查询修复信息
     */
    queryRepairCaseInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryRepairCaseInfo',
        type: requestType.Get
    },
    /**
     * 信修案件池-分案
     */
    distributeRepairCases: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'distributeRepairCases',
        type: requestType.Post
    },
    /**
     * 查看附件信息
     */
    viewUploadFile: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'viewUploadFile',
        type: requestType.Get
    },
    getCollectionTypeByCaseId: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCollectionTypeByCaseId',
        type: requestType.Get
    },
    /**
     * 信修案件批量下载
     */
    downRepairCaseInfos: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'downRepairCaseInfos',
        type: requestType.Get
    },
};
